module.exports = __webpack_public_path__ + "img/ElementaryGroups.7dede8a9.webp";